import React, { useState } from "react";
import Navbar from "../components/ui/Navbar";
import PushNotificationsPanel from "../components/admin/PushNotificationsPanel";
import EmailCampaignsPanel from "../components/admin/EmailCampaignsPanel";
import CommercialProposalsPanel from "../components/admin/CommercialProposalsPanel";
import OverdueNotificationsPanel from "../components/admin/OverdueNotificationsPanel";

const TABS = [
  { id: "push", label: "Push" },
  { id: "email", label: "Email" },
  { id: "propuestas", label: "Propuestas" },
  { id: "vencidos", label: "Vencidos" },
];

const PANELS = {
  push: <PushNotificationsPanel />,
  email: <EmailCampaignsPanel />,
  propuestas: <CommercialProposalsPanel />,
  vencidos: <OverdueNotificationsPanel />,
};

const AdminNotificationsPage = () => {
  const [tab, setTab] = useState("push");

  return (
    <>
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-8 mt-24">
        <div className="flex gap-2 border-b border-gray-200 mb-6">
          {TABS.map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
                tab === t.id
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {PANELS[tab]}
      </div>
    </>
  );
};

export default AdminNotificationsPage;
